import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_segment_RowClass} from '../../dbschema';

export class SegmentCoaContainerModel extends BaseContainerModel {
  bl_fi_mst_segment: bl_fi_mst_segment_RowClass = new bl_fi_mst_segment_RowClass();
}
